import styled from "styled-components";
export const DatePickerContainer = styled.div`
  width: 100%;
  label {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .date-area {
    background-color: ${({ theme }) => theme.colors.background};
    width: 100%;
    position: relative;
    border-radius: 5px;
    border: solid 1px ${({ theme }) => theme.colors.inputBorder};
    border-color: ${({ error, theme }) =>
      error ? "red" : theme.colors.inputBorder};
      padding: 8px;
    .DatePicker {
      width: 100%;
    }
    input {
      background-color: ${({ theme }) => theme.colors.background};
      border: none;
      font-size: 18px;
      width: 100%;
      cursor: pointer;
      height: 27px;
      line-height: 27px;
      &::placeholder {
        font-size: ${({ theme }) => theme.sizes.font1};
      }
    }
    .error {
      position: absolute;
      right: 0;
      color: red;
      font-size: 8px;
      bottom: 0;
      padding: 0 4px;
      background: #fff;
      margin: 1px;
      border-radius: 4px;
      line-height: 9px;
      z-index: 1;
    }
    ${({ required }) =>
      required
        ? `
    &:before {
      background: red;
      width: 5px;
      height: 5px;
      content: "";
      position: absolute;
      top: 3px;
      border-radius: 3px;
      right: 3px;
      z-index: 1;
    }`
        : ""})};
  }

  @media only screen and (max-width: 760px) {
    .date-area {
      padding-bottom: 0;
      input {
        height: 32px;
      }
      .error {
        bottom: -12px;
      }
    }
  }
`;
